import React from 'react';
//import {withRouter} from 'react-router';
import BoxMessage from './BoxMessage';
import BoxHeader from './BoxHeader';
import BoxContent from './BoxContent';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";

/**
 * Components Box
 * @param string props.message 
 * @param object jsx props.header.icon
 * @param string props.header.header
 * @param object jsx props.children
 */
const Box = (props) => {
  const fromSelfCheckin = useFromSelfCheckin(props.location);

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <div className={fromSelfCheckin.isFromSelfCheckin ? "" : "mt-3"}>
      {(props.message) ? <BoxMessage content={props.message} /> : null}
      {(props.header.header) ? <BoxHeader icon={props.header.icon}>{props.header.header}</BoxHeader> : null}
      <BoxContent>{props.children}</BoxContent>
    </div>
  )
}

export default Box;